import React from 'react'
import { Link } from 'react-router-dom'

const Footer: React.FC = () => (
  <footer className="bg-white border-t border-gray-200 mt-12">
    <div className="container mx-auto px-4 py-6 flex flex-col md:flex-row items-center justify-between text-gray-600 text-sm">
      <div className="mb-2 md:mb-0">&copy; {new Date().getFullYear()} AI Decision Maker. All rights reserved.</div>
      <nav className="flex space-x-4">
        <Link to="/about" className="hover:text-primary-700 underline">About Us</Link>
        <Link to="/privacy" className="hover:text-primary-700 underline">Privacy Policy</Link>
        <Link to="/terms" className="hover:text-primary-700 underline">Terms of Service</Link>
        <Link to="/contact" className="hover:text-primary-700 underline">Contact Us</Link>
      </nav>
    </div>
  </footer>
)

export default Footer 